import { useEffect, useState } from 'react';
import { Box, Paper, Typography, useTheme} from '@mui/material';
import { getWeeklyPlanningForecasts, listFormations } from '../api/restaurant';
import { WeeklyShiftForecast } from '../types/api/WeeklyShiftForecast';
import WeeklyShiftsForecastTable from '../components/Tables/WeeklyShiftForecastTable';
import Formation from '../types/api/Formation';
import HistoryIcon from '@mui/icons-material/History';

interface WeeklyShiftsForecastProps {

}

function WeeklyShiftsForecast(WeeklyShiftsForecastProps: WeeklyShiftsForecastProps) {
    const theme = useTheme();
    const [formations, setFormations] = useState<Formation[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [regularShiftsForecasts, setRegularShiftsForecasts] = useState<WeeklyShiftForecast[]>([]);

    const updateFormations = async () => {
        const res = await listFormations();
        if (res && res.code === 200 && res.data) {
            setFormations(res.data);
        }
    };

    const refreshRegularShifts = async () => {
        setIsLoading(true);
        try {
            const res = await getWeeklyPlanningForecasts(null, null);
            if (res && res.data && res.code === 200) {
                setRegularShiftsForecasts(res.data.forecasts);
            }
        } catch (e) {
            console.error('refreshPlanning error', e);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        updateFormations();
        // load regular shifts on mount
        refreshRegularShifts();
    }, []);


    return (
        <Paper>
            {/* Header */}
            <Paper elevation={3} sx={{
                display: 'flex', 
                flexDirection: 'row', 
                justifyContent: 'space-between', 
                alignItems: 'center',
                borderBottom: `1px solid ${theme.palette.divider}`, 
                padding: 3, 
            }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <Box
                        sx={{
                            backgroundColor: 'rgba(255, 255, 255, 0.2)',
                            borderRadius: '12px',
                            padding: 1.5,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                    >
                        <HistoryIcon sx={{ fontSize: '2rem' }} />
                    </Box>
                    <Box>
                        <Typography 
                            variant="h4" 
                            sx={{ 
                                fontWeight: 'bold', 
                                fontSize: { xs: '1.5rem', sm: '1.75rem', md: '2rem' },
                            }}
                        >
                            Gestion des besoins réguliers
                        </Typography>
                        <Typography 
                            variant="body1" 
                            sx={{ 
                                opacity: 0.9,
                                fontSize: '0.95rem'
                            }}
                        >
                            Définissez les shifts récurrents obligatoires pour chaque jour de la semaine
                        </Typography>
                    </Box>
                </Box>
            </Paper>

            <Paper 
                elevation={0}
                sx={{ display: 'flex', gap: 1, width: '100%', flexWrap: 'wrap' }}
            >
                <WeeklyShiftsForecastTable
                    refreshWeeklyShiftsForecasts={refreshRegularShifts}
                    shifts={regularShiftsForecasts} 
                    selectedWeek={null}
                    clientForecasts={[]}
                    formations={formations}
                    regenerateWeeklyShiftsForecasts={null}
                />
            </Paper>

        </Paper>
    );
}

export default WeeklyShiftsForecast;
